import { render } from "./BaseSpinner.vue?vue&type=template&id=02c72488&scoped=true"
const script = {}

import "./BaseSpinner.vue?vue&type=style&index=0&id=02c72488&scoped=true&lang=css"

import exportComponent from "/opt/build/repo/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-02c72488"]])

export default __exports__